import { george, pr, React, theme, ui } from "aaa";
import { themeColors } from "muiTheme";

type NoContentCardProps = {
    title?: string;
    description?: string;
    imgSrc?: string;
    style?: React.CSSProperties;

};

export const NoContentCard: React.FC<NoContentCardProps> = ({
    title,
    description,
    imgSrc,
    style
}) => {
    return (
        <george.Card
            elevated={false}
            style={{
                borderRadius: 8,
                padding: theme.MARGIN_LARGE,
                marginTop: theme.MARGIN,
                textAlign: "center",
                ...style
            }}
        >
            <div style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: theme.MARGIN
            }}>
                {imgSrc && <img
                    src={imgSrc}
                    alt="No products available"
                    style={{
                        width: 100,
                        height: 100
                    }}
                />}
                <div>
                    {title && <pr.P_18_TITLE style={{
                        fontWeight: 700,
                        color: ui.isDarkMode ? "white" : themeColors.george_text_color,
                        marginBottom: theme.MARGIN_SMALL
                    }}>
                        {title}
                    </pr.P_18_TITLE>}
                    {description && <pr.P_16_CONTENT style={{
                        color: ui.isDarkMode ? "white" : themeColors.george_text_color,
                    }}>
                        {description}
                    </pr.P_16_CONTENT>}

                </div>
            </div>
        </george.Card>
    );
}; 


// WEBPACK FOOTER //
// ./src/components/gJunior/components/cards/NoContentCard.tsx